import { Injectable } from "@angular/core";
import { Select, Store } from "@ngxs/store";
import { filter, take, Observable } from "rxjs";
import { IRequest } from "ngxs-requests-plugin";

import { ClearSearchResults, GetFirmConsult, ResetFirmIdsValidation, SearchFirm, ValidateFirmIds } from "../ngxs/firm/firm.actions";
import { GetFirmConsultRequestState, SearchFirmRequestState, ValidateFirmIdsRequestState } from "../ngxs/firm/firm.state";
import { FirmGetterState } from "../ngxs/firm/firm-getter.state";
import { IFirm, IFirmConsult } from "../interfaces/firm.interface";

@Injectable({
  providedIn: 'root'
})
export class FirmService {

  @Select(SearchFirmRequestState)
  searchFirmRequestState$: Observable<IRequest>;

  @Select(GetFirmConsultRequestState)
  getFirmConsultRequestState$: Observable<IRequest>;

  @Select(ValidateFirmIdsRequestState)
  validateFirmIdsRequestState$: Observable<IRequest>;

  @Select(FirmGetterState.getSearchFirms)
  firms$: Observable<IFirm[]>;
  
  @Select(FirmGetterState.getFirmById)
  firmConsultById$: Observable<IFirm | IFirmConsult>;

  @Select(FirmGetterState.getFirmConsultId)
  firmConsultId$: Observable<string>;
  
  @Select(FirmGetterState.getIsLoadingFirm)
  isLoadingFirm$: Observable<boolean>;

  @Select(FirmGetterState.getIsValidatingFirms)
  isValidatingFirms$: Observable<boolean>;

  @Select(FirmGetterState.getLoadingMessage)
  loadingMessage$: Observable<string>;
  
  @Select(FirmGetterState.getValidFirmsList)
  validFirms$: Observable<string[]>;
  
  @Select(FirmGetterState.getInvalidFirmsList)
  invalidFirms$: Observable<string[]>;

  constructor(
    private store: Store,
  ) {}

  getFirmById(firmId: string) {
    return this.store.select(FirmGetterState.getFirmById(firmId));
  }

  getFirmConsultId(): Observable<string> {
    return this.store.select(FirmGetterState.getFirmConsultId);
  }

  getFirmConsult(firmId: string) {
    this.store.dispatch(new GetFirmConsult(firmId));
  }

  searchFirm(input: string) {
    this.store.dispatch(new SearchFirm(input));
  }

  clearSearchResults() {
    this.store.dispatch(new ClearSearchResults());
  }

  validateFirmIds(input : string[]) {
    this.store.dispatch(new ValidateFirmIds(input));
  }

  resetFirmIdsValidation() {
    this.store.dispatch(new ResetFirmIdsValidation());
  }
}
